var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8881 2.66293L11.6296 1.92142C12.8581 0.692859 14.85 0.692859 16.0786 1.92142C17.3071 3.14999 17.3071 5.14188 16.0786 6.37044L15.3371 7.11195M10.8881 2.66293C10.8881 2.66293 10.9807 4.23862 12.3711 5.62894C13.7614 7.01926 15.3371 7.11195 15.3371 7.11195M10.8881 2.66293L4.07106 9.47992C3.60933 9.94165 3.37846 10.1725 3.17992 10.4271C2.94571 10.7273 2.74491 11.0522 2.58107 11.396C2.44219 11.6874 2.33894 11.9972 2.13245 12.6167L1.47133 14.6L1.25745 15.2417M15.3371 7.11195L8.52008 13.9289C8.05835 14.3907 7.82749 14.6215 7.57293 14.8201C7.27265 15.0543 6.94775 15.2551 6.60398 15.4189C6.31256 15.5578 6.00282 15.6611 5.38334 15.8675L3.4 16.5287L2.75834 16.7426M2.75834 16.7426L2.11667 16.9564C1.81182 17.0581 1.47573 16.9787 1.2485 16.7515C1.02128 16.5243 0.941942 16.1882 1.04356 15.8833L1.25745 15.2417M2.75834 16.7426L1.25745 15.2417",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.a221001201ac1e412851f1dba45c50f4.svg";
export { ForwardRef as ReactComponent };